var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('welcome-banner'),_c('v-card',{attrs:{"flat":""}},[_c('v-card-actions',{staticClass:"pa-4"},[_c('search-bar')],1)],1),_c('hot-tags'),_c('graph-list-links'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }